import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.Badge.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckableFieldBadge = _a => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  const {
    id,
    badge
  } = useContext(CheckableFieldContext);
  if (!badge) {
    return null;
  }
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({}, rest), {
    id: "".concat(id, "-badge"),
    className: clsx("pd:checkable-field__badge", className),
    children: badge
  }));
};
var CheckableField_Badge_default = CheckableFieldBadge;
export { CheckableField_Badge_default };